import { ParsedTelemetry, TelemetryFormat } from "../types"
import { parseSrtCues, srtSampleRate } from "./srt"

const gpsPattern = /GPS\(([WE]):\s*(-?[\d.]+),\s*([NS]):\s*(-?[\d.]+),\s*(-?[\d.]+)m\)/
// G.PRY is the gimbal's world orientation; the legacy parser read F.PRY (aircraft attitude), which was a bug
const gimbalPattern = /G\.PRY \((-?[\d.]+)°, (-?[\d.]+)°, (-?[\d.]+)°\)/

const signed = (hemisphere: string, value: number) =>
    hemisphere === "W" || hemisphere === "S" ? -value : value

const parse = (text: string): ParsedTelemetry => {
    const cues = parseSrtCues(text)
    const events = cues.map((cue) => {
        const payload = cue.lines.join("\n")
        const gps = payload.match(gpsPattern)
        const gimbal = payload.match(gimbalPattern)
        return {
            timestamp: cue.start,
            longitude: gps ? signed(gps[1], Number(gps[2])) : NaN,
            latitude: gps ? signed(gps[3], Number(gps[4])) : NaN,
            height: gps ? Number(gps[5]) : NaN,
            elevation: undefined,
            pitch: gimbal ? Number(gimbal[1]) : NaN,
            roll: gimbal ? Number(gimbal[2]) : NaN,
            yaw: gimbal ? Number(gimbal[3]) : NaN,
        }
    })
    return { events, samplesPerSecond: srtSampleRate(cues) }
}

export const autel = {
    name: "autel",
    matches: (prefix) => prefix.includes("HOME("),
    parse,
} satisfies TelemetryFormat
